/* istanbul ignore file */
import { ARTIFACT_ID } from 'domain/shared/artifact';
import { ArtifactUploaderInput, ArtifactUploaderInputProps } from 'domain/shared/artifact/input';

const LeaveApplicationScanUploaderInput = (props: ArtifactUploaderInputProps) => {
  return <ArtifactUploaderInput {...props} artifactTypeId={ARTIFACT_ID.LEAVE_APPLICATION_SCAN} />;
};

export default LeaveApplicationScanUploaderInput;
